import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { routerActions } from "react-router-redux";
import { checkAuthDataValidity } from "./authData";
import { hasToRedirectToPatientPlaylist } from "./AuthTools";

const locationHelper = locationHelperBuilder({});

export default connectedRouterRedirect({
  // TODO redirect may have been added here
  redirectPath: hasToRedirectToPatientPlaylist()
    ? "/patient-playlists"
    : (state, ownProps) => {
        return locationHelper.getRedirectQueryParam(ownProps) || "/";
      },
  allowRedirectBack: false,
  authenticatedSelector: (state) => {
    const { authData } = state.login;
    //   console.log(subdomain)
    return typeof authData === "undefined" || !checkAuthDataValidity(authData);
  },
  wrapperDisplayName: "UserNotAuthenticated",
  redirectAction: routerActions.replace,
});



// WEBPACK FOOTER //
// ./src/pages/utils/auth/UserNotAuthenticated.js